<template>
  <div class="policy-container">
    <h1>개인정보처리방침</h1>

    <section>
      <h2>1. 수집하는 개인정보 항목</h2>
      <p>
        본 서비스는 게스트 사용자의 경우 개인정보를 수집하지 않으며, 사용자가
        자발적으로 정보를 입력하는 경우에 한해 다음과 같은 최소한의 정보를
        수집합니다:
      </p>
      <ul>
        <li>이름 (닉네임 형태 가능)</li>
        <li>생년월일</li>
        <li>성별</li>
      </ul>
    </section>

    <section>
      <h2>2. 개인정보의 수집 및 이용 목적</h2>
      <p>
        수집된 정보는 사용자 맞춤형 서비스 제공을 위한 사주 분석, 오행 분석 등
        철학적 해석의 근거로만 사용됩니다. 해당 정보는 외부로 제공되거나
        마케팅에 사용되지 않습니다.
      </p>
    </section>

    <section>
      <h2>3. 개인정보의 보관 및 파기</h2>
      <p>
        수집된 정보는 사용자가 서비스를 이용하는 동안 안전하게 보관되며,
        사용자가 삭제 요청을 하거나 일정 기간 서비스 미이용 시 자동으로
        삭제됩니다.
      </p>
    </section>

    <section>
      <h2>4. 이용자의 권리</h2>
      <p>
        사용자는 본인의 개인정보를 열람하거나 수정, 삭제 요청할 수 있으며,
        이러한 요청은 언제든지 고객지원 또는 설정 메뉴를 통해 가능합니다.
      </p>
    </section>

    <section>
      <h2>5. 개인정보 보호 책임자</h2>
      <p>
        본 서비스는 개인정보 보호를 위해 최선을 다하고 있으며, 문의사항은 아래
        연락처로 접수해 주시기 바랍니다:
      </p>
      <ul>
        <li>담당자: 개인정보 보호 책임자</li>
        <li>이메일: kayroh@lydiatree.kr</li>
      </ul>
    </section>
    <p>
      본 개인정보처리방침은 리디아트리(사업자등록번호:437-20-01228)에서 제공하는
      '인생의 역점' 서비스에 적용됩니다.
    </p>

    <div class="button-container">
      <button class="confirm-button" @click="goBack">확인</button>
    </div>
  </div>
</template>

<script setup>
  import { useRouter } from 'vue-router'
  const router = useRouter()
  const goBack = () => {
    router.go(-1)
  }
</script>

<style scoped>
  .policy-container {
    max-width: 480px;
    margin: 0 auto;
    padding: 2rem;
    font-size: var(--font-size-095);
    line-height: 1.6;
  }

  h1 {
    font-size: var(--font-size-14);
    margin-bottom: 1rem;
  }

  h2 {
    font-size: var(--font-size-11);
    margin-top: 1.5rem;
  }

  ul {
    padding-left: 1.2rem;
    list-style: disc;
  }

  .button-container {
    margin-top: 2rem;
    display: flex;
    justify-content: center;
  }

  .confirm-button {
    padding: 0.7rem 1.5rem;
    font-size: var(--font-size-10);
    border: none;
    border-radius: 8px;
    background-color: #4caf50;
    color: white;
    cursor: pointer;
  }

  .confirm-button:hover {
    background-color: #45a049;
  }
</style>
